<div class="aside has-header has-footer has-margin-icon">

    <div class="aside-header">
        <div class="row">
            <div class="col-auto">
                <i class="header-icon icon-oc-border"></i>
            </div>
            <div class="col">
                <div class="title title-bg">
                    <h2 class="title-main">{{'LABEL.FRONTIER_HEADER' | translate}}</h2>
                </div>
            </div>
        </div>
    </div>

    <div class="aside-content">
        <div class="aside-content-body">
            <div class="section">
                <div class="section-content">
                    <div class="separator"></div>

                    <h3 class="page-subheader">{{'OFFER_CONFIG.POLICY_DATA' | translate}}</h3>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-output [label]="'OFFER_CONFIG.TYPE_OF_POLICY' | translate">
                                {{ (product.configuration.continuation.selected ? 'CALCULATION_SUBJECT.CONTINUATION' : 'CALCULATION_SUBJECT.NEW_POLICY') | translate }}
                            </app-output>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'INSURANCE_PERIOD' | translate }}</h3>

                    <div class="row form-row">
                        <div class="col-4">

                            <app-output [label]="'OFFER_CONFIG.INSURANCE_DATE_FROM' | translate">
                                {{ product.configuration.insuranceStartDate }}
                            </app-output>
                        </div>
                        <div class="col-4">
                            <app-output [label]="'OFFER_CONFIG.INSURANCE_DATE_TO' | translate">
                                {{ product.configuration.insuranceEndDate }}
                            </app-output>
                        </div>
                    </div>

                    <div class="separator"></div>


                    <ng-container
                            *ngIf="product.configuration.vehicleDefinition.mode === vehicleDefinitionMode.EUROTAX">
                        <h3 class="page-subheader">{{'MOTOR_CONFIG.MOTOR_DATA_EUROTAX' | translate}}</h3>

                        <div class="row form-row">
                            <div class="col-4">

                                <app-output [label]="'MOTOR_CONFIG.EUROTAX_CODE' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.modelId }}

                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4">

                                <app-output [label]="'MOTOR_CONFIG.MOTOR_TYPE' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.categoryDescription }}

                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MANUFACTURE_YEAR' | translate">
                                    {{ product.configuration.vehicleDefinition.productionYear }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MAKE' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.makeDescription }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MODEL' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.modelDescription }}

                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.BODY_TYPE' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.bodyTypeItem?.description }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.DOOR_NUMBER' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.doorCount }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.FUEL_TYPE' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.fuelTypeItem.description }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.ENGINE_SIZE' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.capacity | suffixLabel : 'LABEL.SUFFIX_CM3'}}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.TRANSMISSION' | translate">
                                    {{ product.configuration.vehicleDefinition.eurotax.gearBoxTypeItem.description }}
                                </app-output>
                            </div>
                        </div>
                    </ng-container>


                    <ng-container *ngIf="product.configuration.vehicleDefinition.mode === vehicleDefinitionMode.MANUAL">
                        <h3 class="page-subheader">{{'MOTOR_CONFIG.MOTOR_DATA_EUROTAX' | translate}}</h3>

                        <div class="row form-row">
                            <div class="col-4">

                                <app-output [label]="'MOTOR_CONFIG.MOTOR_TYPE' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.type?.description }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MANUFACTURE_YEAR' | translate">
                                    {{ product.configuration.vehicleDefinition.productionYear }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MAKE' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.make }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MODEL' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.model }}

                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.BODY_TYPE' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.bodyType?.description }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.DOOR_NUMBER' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.doors?.description }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.FUEL_TYPE' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.fuelType?.description }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.VERSION' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.version }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.ENGINE_SIZE' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.engineCapacity | suffixLabel : 'LABEL.SUFFIX_CM3' }}
                                </app-output>
                            </div>
                        </div>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.KW' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.enginePower | suffixLabel : 'LABEL.SUFFIX_KW' }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.LOAD_CAPACITY' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.loadCapacity | suffixLabel : 'LABEL.SUFFIX_KG' }}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'MOTOR_CONFIG.MAXIMUM_WEIGHT' | translate">
                                    {{ product.configuration.vehicleDefinition.manual.maximumWeight | suffixLabel : 'LABEL.SUFFIX_KG' }}
                                </app-output>
                            </div>
                        </div>
                    </ng-container>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-output [label]="'MOTOR_CONFIG.REGISTRATION_NUMBER' | translate">
                                {{ product.configuration.vehicleDefinition.licensePlate }}
                            </app-output>
                        </div>

                        <div class="col-4">
                            <app-output [label]="'MOTOR_CONFIG.VIN' | translate">
                                {{ product.configuration.vehicleDefinition.vin }}
                            </app-output>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-output [label]="'LABEL.VEHICLE_ORIGIN_COUNTRY' | translate">
                                {{ product.configuration.vehicleOriginCountry?.description }}
                            </app-output>
                        </div>
                    </div>

                    <ng-container *ngIf="product.configuration.premium">

                        <div class="separator"></div>

                        <div class="row">
                            <div class="col">
                                <h3 class="page-subheader">{{'OFFER_CONFIG.PAYMENTS' | translate}}</h3>
                            </div>
                            <div class="col-auto size-half-insurance h3 page-subheader">
                                <!--        Wysokość i termin płatności raty-->
                            </div>
                        </div>

                        <div class="separator"></div>

                        <div class="row form-row">
                            <div class="col-4">
                                <app-output [label]="'INSTALLMENT_NUMBER' | translate">
                                    {{ product.configuration.paymentDefinition.installments?.description}}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <app-output [label]="'INSTALLMENT_POSTPONEMENT' | translate">
                                    {{ product.configuration.paymentDefinition.deferredPayment?.description}}
                                </app-output>
                            </div>

                            <div class="col-4">
                                <div class="row" *ngIf="product.configuration.paymentDefinition.installmentList">
                                    <div class="col-3"
                                         *ngFor="let element of product.configuration.paymentDefinition.installmentList">
                                        <!--                                            {{ 'OFFER_CONFIG.DATE_OF_PAYMENT' | translate }}-->
                                        <div class="inst">
                                            <div class="item-amount">{{ element.amount | premium }}</div>
                                            <div class="item-date">{{ element.date | lsnDate }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="separator"></div>

                        <hr/>

                        <div class="separator"></div>

                        <div class="row" *ngIf="product.configuration.premium !== null">
                            <div class="col">
                                {{ 'OFFER_CONFIG.TOTAL_PREMIUM' | translate }}
                            </div>
                            <div class="col-auto">
                                <div class="text-price">
                                    <div class="item-price">
                                        {{ product.configuration.premium | premium }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                </div>
            </div>

        </div>
    </div>

    <div class="aside-footer">
        <div class="footer-btn">
            <button (click)="close()"
                    class="btn btn-secondary"
                    type="button">{{ 'BUTTON.CLOSE' | translate }}</button>
        </div>
    </div>
</div>
